import React from 'react';

function CrossLargeSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.94975 5.63616C6.34028 5.24563 6.97344 5.24563 7.36397 5.63616L12.3137 10.5859L17.2635 5.63616C17.654 5.24563 18.2872 5.24563 18.6777 5.63616C19.0682 6.02668 19.0682 6.65984 18.6777 7.05037L13.7279 12.0001L18.6777 16.9499C19.0682 17.3404 19.0682 17.9736 18.6777 18.3641C18.2872 18.7546 17.654 18.7546 17.2635 18.3641L12.3137 13.4143L7.36397 18.3641C6.97344 18.7546 6.34028 18.7546 5.94975 18.3641C5.55923 17.9736 5.55923 17.3404 5.94975 16.9499L10.8995 12.0001L5.94975 7.05037C5.55923 6.65984 5.55923 6.02668 5.94975 5.63616Z"
      />
    </svg>
  );
}

export default CrossLargeSVG;
